import { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Card, Form, Input, Space, Typography } from "antd";
import AuthShell from "components/auth/AuthShell";
import AuthBrand from "components/auth/AuthBrand";
import useAccountRecovery from "hooks/auth/useAccountRecovery";
import paths from "routes/paths";

const { Title, Text, Paragraph } = Typography;

const AuthRecoverVerify = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { verifyCode, email, isLoading } = useAccountRecovery();

  const activeEmail = useMemo(
    () => location.state?.email || email || "your email",
    [email, location.state?.email],
  );

  const submit = async (values) => {
    if (!values.code) return;
    const res = await verifyCode(values.code);
    if (res?.success) {
      navigate(paths.simpleResetPassword, { replace: true });
    }
  };

  return (
    <AuthShell>
      <Card
        variant="borderless"
        style={{
          width: "100%",
          maxWidth: 520,
          borderRadius: 28,
          boxShadow: "0 24px 70px rgba(15, 23, 42, 0.10)",
          border: "1px solid rgba(226,232,240,0.95)",
          background: "rgba(255,255,255,0.92)",
          backdropFilter: "blur(18px)",
        }}
        styles={{ body: { padding: 32 } }}
      >
        <div style={{ marginBottom: 24, textAlign: "center" }}>
          <AuthBrand centered size={96} />
        </div>
        <Space vertical size={8} style={{ width: "100%" }}>
          <Text
            style={{
              textTransform: "uppercase",
              letterSpacing: "0.14em",
              color: "#64748b",
              fontSize: 12,
              fontWeight: 700,
            }}
          >
            Verify request
          </Text>
          <Title level={2} style={{ margin: 0, color: "#111827" }}>
            Enter verification code
          </Title>
          <Paragraph style={{ marginBottom: 0, color: "#475569" }}>
            We sent a code to <Text strong>{activeEmail}</Text>. Enter it here to
            continue.
          </Paragraph>
        </Space>

        <Form layout="vertical" requiredMark={false} onFinish={submit} style={{ marginTop: 24 }}>
          <Form.Item
            label="Verification code"
            name="code"
            rules={[{ required: true, message: "Enter the verification code" }]}
          >
            <Input
              placeholder="123456"
              disabled={isLoading}
              size="large"
              inputMode="numeric"
            />
          </Form.Item>

          <Space style={{ width: "100%", justifyContent: "space-between" }} wrap>
            <Button onClick={() => navigate(paths.simpleLogin)} disabled={isLoading}>
              Back to sign in
            </Button>
            <Button
              type="primary"
              htmlType="submit"
              loading={isLoading}
              style={{ backgroundColor: "#22c55e", borderColor: "#22c55e" }}
            >
              Verify code
            </Button>
          </Space>
        </Form>
      </Card>
    </AuthShell>
  );
};

export default AuthRecoverVerify;
